var render = function render(){var _vm=this,_c=_vm._self._c;return _c('other-scars-template',{attrs:{"mishap-scars-size":_vm.mishapScarsSize,"title":_vm.scarsSizeTitle,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }